import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { db } from '../firebase';
import { collection, getDocs, addDoc } from 'firebase/firestore';
import './POWiseMaterialDemanded.css';

function POWiseMaterialDemanded() {
  const { jcNumber } = useParams();
  const navigate = useNavigate(); // ✅ For back button
  const [demands, setDemands] = useState([]);
  const [newDemand, setNewDemand] = useState({
    item_name: '',
    make: '',
    specification: '',
    quantity: '',
    deadline: ''
  });
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const snap = await getDocs(collection(db, 'material_requests'));
      const data = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      const filtered = data.filter(d => d.jc_number === jcNumber);
      setDemands(filtered);
    };
    fetchData();
  }, [jcNumber]);

  const handleSubmit = async () => {
    const fields = Object.values(newDemand);
    if (fields.some(val => !val)) return alert('Please fill all fields');

    await addDoc(collection(db, 'material_requests'), {
      ...newDemand,
      jc_number: jcNumber,
      po_id: `PO-${jcNumber}`,
      status: 'Pending',
      created_at: new Date().toISOString()
    });

    alert('Material requested');

    setNewDemand({
      item_name: '',
      make: '',
      specification: '',
      quantity: '',
      deadline: ''
    });

    const snap = await getDocs(collection(db, 'material_requests'));
    const data = snap.docs.map(d => ({ id: d.id, ...d.data() }));
    const filtered = data.filter(d => d.jc_number === jcNumber);
    setDemands(filtered);
  };

  return (
    <div className="material-demand-container">
      <button className="back-btn" onClick={() => navigate(-1)}>← Back</button>

      <h2>Material Demands for JC: {jcNumber}</h2>

      <div className="accordion">
        <div className="accordion-header" onClick={() => setShowForm(!showForm)}>
          <h3>➕ New Material Demand</h3>
        </div>
        {showForm && (
          <div className="accordion-body">
            <div className="demand-form">
              {['item_name', 'make', 'specification', 'quantity', 'deadline'].map(field => (
                <div key={field} className="form-group">
                  <label htmlFor={field}>
                    {field.replace('_', ' ').replace(/\b\w/g, c => c.toUpperCase())}
                  </label>
                  <input
                    id={field}
                    type={field === 'quantity' ? 'number' : field === 'deadline' ? 'date' : 'text'}
                    placeholder={field.replace('_', ' ').toUpperCase()}
                    value={newDemand[field]}
                    onChange={e => setNewDemand({ ...newDemand, [field]: e.target.value })}
                  />
                </div>
              ))}
              <button onClick={handleSubmit}>Request Material</button>
            </div>
          </div>
        )}
      </div>

      <table className="demand-table">
        <thead>
          <tr>
            <th>Item</th>
            <th>Make</th>
            <th>Spec</th>
            <th>Qty</th>
            <th>Deadline</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {demands.map((d, i) => (
            <tr key={i}>
              <td>{d.item_name}</td>
              <td>{d.make}</td>
              <td>{d.specification}</td>
              <td>{d.quantity}</td>
              <td>{d.deadline}</td>
              <td>
                <span className={`status-${d.status.toLowerCase()}`}>
                  {d.status}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default POWiseMaterialDemanded;
